import { useReactiveVar } from '@apollo/client';
import { Layout } from 'antd';
import { isWaitingUserVar, isLoggedInVar } from 'api/cache';
import Sidebar from 'components/Sidebar';
import Header from 'containers/Header';
import React, { useMemo } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { privateRoutes, publicRoutes } from 'routes';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';

const { Content } = Layout;

const MainLayout = () => {
  const isLoggedIn = useReactiveVar(isLoggedInVar);

  const params = useMemo(
    () =>
      '?redirect=' +
      encodeURIComponent(
        window.location.href.replace(window.location.origin, '')
      ),
    []
  );

  const isWaitingUser = useReactiveVar(isWaitingUserVar);

  return (
    <BrowserRouter>
      <Layout style={{ minHeight: '100vh' }}>
        <Switch>
          {publicRoutes.map(route => (
            <PublicRoute
              key={route.path}
              path={route.path}
              exact={route.exact}
              isLoggedIn={isLoggedIn}
            >
              <route.component />
            </PublicRoute>
          ))}
          {isLoggedIn ? (
            <Route>
              <Sidebar />
              <Layout className="site-layout">
                <Header />
                <Content className="navi-content-wrapper">
                  <Switch>
                    {privateRoutes.map(route => (
                      <PrivateRoute
                        key={route.path}
                        path={route.path}
                        exact={route.exact}
                        keyCode={route?.keyCode}
                        isLoggedIn={isLoggedIn}
                      >
                        <route.component />
                      </PrivateRoute>
                    ))}

                    <Route path="*">
                      <Redirect to="/404" />
                    </Route>
                  </Switch>
                  <Switch>{isWaitingUser && <Redirect to="/ca-nhan" />}</Switch>
                </Content>
              </Layout>
            </Route>
          ) : (
            <Redirect to={'/dang-nhap' + params} />
            // <Route>
            //   <Sidebar />
            //   <Layout className="site-layout">
            //     <Header />
            //     <Content className="navi-content-wrapper">
            //       <Switch>
            //         {privateRoutes.map(route => (
            //           <PrivateRoute
            //             key={route.path}
            //             path={route.path}
            //             exact={route.exact}
            //             keyCode={route?.keyCode}
            //             isLoggedIn={isLoggedIn}
            //           >
            //             <route.component />
            //           </PrivateRoute>
            //         ))}
            //         <Route path="*">
            //           <Redirect to="/404" />
            //         </Route>
            //       </Switch>
            //     </Content>
            //   </Layout>
            // </Route>
          )}
        </Switch>
      </Layout>
    </BrowserRouter>
  );
};

export default MainLayout;
